<qwiko-splash-loader *ngIf="loading()"></qwiko-splash-loader>

<ng-container *transloco="let t; prefix: 'business_profile'">
  <div
    class="flex flex-col max-w-lg max-h-screen overflow-y-auto relative m-auto"
  >
    <div
      class="bg-white dark:bg-base-100 card z-[10] absolute top-0 h-40 w-full m-auto rounded-t-none rounded-b-box overflow-hidden"
      [ngClass]="{
        'pb-40 ': !bannerLink(),
      }"
    >
      @if (bannerLink()) {
        <figure *ngIf="bannerLink()" class="rounded-b-box">
          <img class="w-full h-full object-cover" [src]="bannerLink()" />
        </figure>
      }
    </div>
    <div class="flex w-full max-w-md z-[50] h-full overflow-y-auto m-auto">
      <div
        class="flex flex-col rounded-t-box w-full h-full px-2 pt-3 pb-10 relative mt-40"
      >
        <section
          class="relative z-[50] bg-white dark:bg-base-100 py-2 rounded-box shadow-sm"
        >
          @if (logo()) {
            <div
              class="avatar self-center w-full justify-center bg-transparent -mt-16"
            >
              <div class="size-20 overflow-hidden relative flex self-center">
                <img
                  class="absolute w-full h-full object-cover rounded-box"
                  [src]="logoLink()"
                />
              </div>
            </div>
          }
          <!-- <span class="loading loading-spinner text-4xl"></span> -->
          <section class="text-center z-[40]">
            <h1 class="font-semibold text-xl">
              {{ business()?.store_name }}
            </h1>
            <p class="text-sm dark:text-neutral-400 text-neutral-400">
              {{ selectedCity()?.name }},
              {{ $any(business()?.country).name }}
            </p>
            <section
              class="flex gap-2 m-auto justify-center items-center rounded-box p-2 w-fit"
            >
              <a
                [href]="callString()"
                class="btn btn-sm bg-base-300 dark:bg-base-200 hover:md:btn-primary rounded-box px-4 py-0"
              >
                <div class="flex items-center gap-1">
                  <i class="fa-solid fa-phone text-sm"></i>
                  <span class="mt-1 text-base"> {{ t("call") }}</span>
                </div>
              </a>
              <!-- <a
                *ngIf="business()?.wifi_name"
                [href]="wifiString"
                class="btn bg-base-300 dark:bg-base-200 hover:md:btn-primary rounded-box px-4 py-0 !size-auto"
              >
                <div class="flex items-center gap-1">
                  <i class="fa-solid fa-wifi text-lg"></i>
                  <span> {{ t("wifi") }}</span>
                </div>
              </a> -->
            </section>
          </section>
        </section>

        <section class="flex w-full">
          <div
            class="collapse collapse-arrow bg-white dark:bg-base-100 rounded-box mt-2 shadow-sm"
          >
            <input type="checkbox" name="payment_methods" checked />
            <div class="collapse-title font-normal">
              {{ t("payment_methods") }}
            </div>
            <div class="collapse-content bg-base-200 px-2">
              @for (
                account of businessPaymentAccounts();
                track $index;
                let count = $count
              ) {
                @if (loading()) {
                  <div
                    class="flex items-center justify-center gap-2 rounded-box px-4 py-2 text-neutral-400 text-center my-2"
                  >
                    <span class="loading loading-spinner w-9"></span>
                  </div>
                } @else {
                  <button
                    (click)="selectAccount(account)"
                    type="button"
                    [disabled]="loading()"
                    class="btn flex flex-row justify-between items-center p-2 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-fit hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
                  >
                    <div
                      class="flex flex-row gap-3 justify-center items-center"
                    >
                      <div class="rounded-full size-11 bg-neutral-400">
                        <img
                          src="/assets/icons/providers/{{
                            account.payment_provider?.icon
                          }}"
                          class=""
                          alt=""
                        />
                      </div>
                      <div class="flex flex-col items-start">
                        <span class="text-base">{{
                          $any($any(account)?.payment_provider)?.name
                        }}</span>
                        <span
                          class="text-md text-neutral-500 dark:text-neutral-400"
                          >{{ account.number_display }}</span
                        >
                      </div>
                    </div>
                    <i
                      class="fa-light fa-chevron-right text-neutral-500 text-xl mr-1"
                    ></i>
                  </button>
                }
              } @empty {
                @if (loading()) {
                  <div
                    class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
                  >
                    <span class="loading loading-spinner w-9"></span>
                  </div>
                } @else {
                  <div
                    class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
                  >
                    <i class="fa-light fa-xmark-to-slot text-lg"></i>
                    <p class="text-md mt-1">
                      {{ t("no_payment_accounts") }}
                    </p>
                  </div>
                }
              }
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-container>

<qwiko-new-payment
  [amount]="amount()"
  [paymentAccount]="selectedAccount()"
  [customerNumber]="customerNumber()"
  [transaction]="transaction()"
  [hasTransaction]="isTransaction()"
></qwiko-new-payment>
<!-- <router-outlet></router-outlet> -->
